module.exports = __webpack_public_path__ + "img/logo-vistat-modern-white.54c1160.svg";